import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/skills';

export const addSkill = async (payload) => await ajax('POST', rootUrl, JSON.stringify(payload));

export const updateSkill = async ({ skillKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${skillKey}`, JSON.stringify(payload));

export const deleteSkill = async (skillKey) => await ajax('DELETE', `${rootUrl}/${skillKey}`);
